var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 8.7H8.5M5 11.5H11.3M13.4 5.2C13.9569 5.2 14.4911 4.97875 14.8849 4.58492C15.2787 4.1911 15.5 3.65695 15.5 3.1C15.5 2.54305 15.2787 2.0089 14.8849 1.61508C14.4911 1.22125 13.9569 1 13.4 1C12.843 1 12.3089 1.22125 11.9151 1.61508C11.5212 2.0089 11.3 2.54305 11.3 3.1C11.3 3.65695 11.5212 4.1911 11.9151 4.58492C12.3089 4.97875 12.843 5.2 13.4 5.2Z",
    stroke: "#176318",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.89999 1H6.39999C2.9 1 1.5 2.4 1.5 5.9V10.1C1.5 13.6 2.9 15 6.39999 15H10.6C14.1 15 15.5 13.6 15.5 10.1V6.6",
    stroke: "#176318",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.87d5a04dac69e4a903dba412bb23a1ce.svg";
export { ForwardRef as ReactComponent };